import React, { useEffect, useState } from "react";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";
import { Modal, Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";

function PromoterDetail({ promoter, startTime, endTime, back }) {
  const [pitches, setPitches] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const queryString =
      `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/pitch_analytics?` +
      `profile_id=eq.${promoter.profile_id}&sent_at=gte.${startTime}&sent_at=lt.${endTime}`;
    fetch(queryString, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        const data = responseJson.map((pitch) => {
          let pitchPoints = 0;
          if (pitch.pitch_speed_category === "fast") pitchPoints += 5;
          else if (pitch.pitch_speed_category === "average") pitchPoints += 2;

          let convoPoints = 0;
          if (pitch.business_status === "sent_without_response") convoPoints += 0;
          else if (pitch.business_status === "media_replied_without_promoter_response") convoPoints += 1;
          else convoPoints += 5;

          return {
            ...pitch,
            pitch_speed_points: pitchPoints,
            conversation_outcome_points: convoPoints,
          };
        });
        setPitches(data);
      })
      // eslint-disable-next-line no-alert
      .catch((error) => alert(`Error: ${error}`));
  }, [promoter.profile_id, startTime, endTime]);

  useEffect(() => {
    const queryString = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/conversation_analytics?receiver_profile_id=eq.${promoter.profile_id}&message_business_type=neq.pitch_reply`;
    fetch(queryString, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        const data = responseJson.map((convo) => {
          let convoPoints = 0;
          if (convo.is_sender && convo.message_business_type === "direct_media_message") convoPoints += 5;

          return {
            ...convo,
            direct_media_reply_points: convoPoints,
          };
        });
        setConversations(data);
      })
      // eslint-disable-next-line no-alert
      .catch((error) => alert(`Error: ${error}`));
  }, [promoter.profile_id]);

  const handleShowModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setShowModal(false);
  };

  // Apply transformation to constrain image to max 45px width
  const max45pxProfileImageUrl = promoter.profile_image_url.replace(
    /upload\/v\d+\//,
    "upload/w_45,q_auto,f_auto,c_scale/",
  );

  return (
    <div className="col-12">
      <div className="row">
        <p>
          <button type="button" className="btn btn-link" onClick={() => back()}>
            <i className="fa-solid fa-chevron-left" />
            &nbsp; Back
          </button>
        </p>
        <h2>
          <ImageCropped
            roundedCircle
            wrapperClasses="me-2"
            src={max45pxProfileImageUrl}
            alt={promoter.profile_name}
            size={45}
          />
          {promoter.profile_name} Detail
        </h2>
      </div>

      <div className="col-12 col-md-6">
        <Table striped bordered hover className="col-12 col-md-6">
          <tbody>
            <tr>
              <td>Promo entities represented</td>
              <td>{promoter.num_represented}</td>
            </tr>
            <tr>
              <td>Profile ID</td>
              <td>{promoter.profile_id}</td>
            </tr>
            <tr>
              <td>Profile Slug</td>
              <td>{promoter.profile_slug}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{promoter.email}</td>
            </tr>
            <tr>
              <td>Company</td>
              <td>
                <a href={`/companies/${promoter.company_slug}`}>{promoter.company_name}</a>
              </td>
            </tr>
            <tr>
              <td>V1 Profile ID</td>
              <td>
                <a href={`http://app.qwoted.com/pr_users/${promoter.v1_profile_id}?version=v1`}>
                  {promoter.v1_profile_id}
                </a>
              </td>
            </tr>
            <tr>
              <td>V1 User ID</td>
              <td>
                <a href={`http://app.qwoted.com/users/${promoter.v1_user_id}`}>{promoter.v1_user_id}</a>
              </td>
            </tr>
            <tr>
              <td>Number of Pitches</td>
              <td>
                <a href={`http://app.qwoted.com/users/${promoter.v1_user_id}/user_pitches`}>{promoter.num_pitches}</a>
              </td>
            </tr>
            <tr>
              <td>Number of Conversations</td>
              <td>
                <a href={`http://app.qwoted.com/users/${promoter.v1_user_id}/conversations`}>
                  {promoter.num_conversations + promoter.num_direct_media_replies}
                </a>
              </td>
            </tr>
            <tr>
              <td>Number of Direct Media Replies</td>
              <td>{promoter.num_direct_media_replies}</td>
            </tr>
            <tr>
              <td>Direct Media Reply Points</td>
              <td>{promoter.direct_media_reply_points}</td>
            </tr>
            <tr>
              <td>Pitch Speed Points</td>
              <td>{promoter.pitch_speed_points || "N/A"}</td>
            </tr>
            <tr>
              <td>Conversation Outcome Points</td>
              <td>{promoter.conversation_outcome_points}</td>
            </tr>
            <tr>
              <td>Bad Behavior Points</td>
              <td>{promoter.bad_behavior_points}</td>
            </tr>
            <tr>
              <td>Ineligible</td>
              <td>{promoter.ineligible ? "Yes" : "No"}</td>
            </tr>
            <tr>
              <td>Disabled Interactions Bad Behavior Points</td>
              <td>{promoter.disabled_interactions_bad_behavior_points}</td>
            </tr>
            <tr>
              <td>Spam Flagged Count Bad Behavior Points</td>
              <td>{promoter.spam_flagged_count_bad_behavior_points}</td>
            </tr>
            <tr>
              <td>Suspected Leaker Dialog Enabled Count Bad Behavior Points</td>
              <td>{promoter.suspected_leaker_dialog_enabled_count_bad_behavior_points}</td>
            </tr>
            <tr>
              <td>Total Points</td>
              <td>{promoter.total_points}</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="col-12">
        <h3>Pitches</h3>

        <table className="table">
          <thead>
            <tr>
              <th>Request & Pitch ID</th>
              <th>Time to pitch</th>
              <th>
                Speed
                <br />
                category
              </th>
              <th>
                Speed
                <br />
                points
              </th>
              <th>Bidirectional</th>
              <th>
                Num
                <br />
                messages
              </th>
              <th>
                Engagement
                <br />
                ratio
              </th>
              <th>
                Conversation
                <br />
                outcome
                <br />
                points
              </th>
              <th>Total points</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {pitches.map((pitch) => (
              <tr key={pitch.pitch_id}>
                <td>
                  {pitch.request_id && (
                    <a href={`/my_requests/${pitch.request_id}`}>
                      {pitch.request_id}; {pitch.pitch_id}
                    </a>
                  )}
                  {!pitch.request_id && <>deleted; {pitch.pitch_id}</>}
                </td>
                <td>{pitch.time_to_pitch}</td>
                <td>{pitch.pitch_speed_category}</td>
                <td>{pitch.pitch_speed_points}</td>
                <td>{pitch.conversation_bidirectional && "true"}</td>
                <td>{pitch.conversation_num_messages}</td>
                <td>{pitch.conversation_engagement_ratio.toFixed(2)}</td>
                <td>{pitch.conversation_outcome_points}</td>
                <td>{pitch.pitch_speed_points + pitch.conversation_outcome_points}</td>
                <td>
                  <button type="button" className="btn btn-link" onClick={() => handleShowModal(pitch)}>
                    Details
                  </button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="6" />
              <td>Totals</td>
              <td>{pitches.reduce((total, pitch) => total + pitch.pitch_speed_points, 0)}</td>
              <td>{pitches.reduce((total, pitch) => total + pitch.conversation_outcome_points, 0)}</td>
              <td>
                {pitches.reduce(
                  (total, pitch) => total + pitch.pitch_speed_points + pitch.conversation_outcome_points,
                  0,
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="col-12">
        <h3>Direct Conversations</h3>

        <table className="table">
          <thead>
            <tr>
              <th>Conversation ID</th>
              <th>Origin</th>
              <th>Receiver Profile ID</th>
              <th>Conversation Migrate ID</th>
              <th>Is Sender</th>
              <th>Message Business Type</th>
              <th>Points</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {conversations.map((conversation) => (
              <tr key={conversation.conversation_id}>
                <td>{conversation.conversation_id}</td>
                <td>
                  {conversation.origin_type} {conversation.origin_id}
                </td>
                <td>{conversation.receiver_profile_id}</td>
                <td>
                  <a
                    href={`https://app.qwoted.com/users/${promoter.v1_user_id}/conversations/${conversation.conversation_migrate_id}`}
                  >
                    {conversation.conversation_migrate_id}
                  </a>
                </td>
                <td>{conversation.is_sender ? "Yes" : "No"}</td>
                <td>{conversation.message_business_type}</td>
                <td>{conversation.direct_media_reply_points}</td>
                <td>
                  <button type="button" className="btn btn-link" onClick={() => handleShowModal(conversation)}>
                    Details
                  </button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="5" />
              <td>Total</td>
              <td>{conversations.reduce((total, convo) => total + convo.direct_media_reply_points, 0)}</td>
              <td />
            </tr>
          </tbody>
        </table>
      </div>

      <Modal dialogClassName="modal-lg" show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedItem && selectedItem.conversation_id ? "Conversation Details" : "Pitch Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <table className="table">
              <tbody>
                {Object.entries(selectedItem).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PromoterDetail;
